import React from "react";
import "./style.scss";

const Toast = (props) => {
  return (
    <div className="toast">{props.tip}</div>
  );
};
export default Toast;
